import { ESessionStorageKeys, Loader, useMerchantById } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { AxiosError } from 'axios'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { trackGetStartedEvent } from '../../services/trackingEvents'
import { CreditApplication } from '../../types/Schemas/CreditApplicationSchema'
import { buildDefaultCreditApplication } from '../SubmitNewApp/submit-app-hooks'

const WelcomePage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchantId } = useParams()

  const [merchant, isFetchingMerchant, error] = useMerchantById(merchantId!, EFinancingProgram.MechanicalWarranty)

  useEffect(() => {
    if (error || (merchant === null && !isFetchingMerchant)) {
      if ((error as AxiosError)?.response?.status === 403) {
        navigate('/get-merchant-error/inactive')
      } else if ((error as AxiosError)?.response?.status === 404) {
        navigate('/get-merchant-error/not-found')
      } else {
        navigate('/general-error-page/error')
      }
    }
  }, [error, isFetchingMerchant, merchant, navigate])

  if (isFetchingMerchant) return <Loader title={t('common.withYouShortly')} description={t('common.pleaseWait')} />

  const handleGetStarted = (isSinglePayment = false) => {
    trackGetStartedEvent(merchantId!)

    const savedInfo = sessionStorage.getItem(ESessionStorageKeys.CREDIT_APPLICATION_INFO)
    let creditApp: CreditApplication

    if (savedInfo) {
      creditApp = JSON.parse(savedInfo) as CreditApplication
      creditApp.isSinglePayment = isSinglePayment

      if (isSinglePayment) {
        creditApp.applicant.currentJobs = []
        creditApp.applicant.otherIncomes = []
      }
    } else {
      creditApp = buildDefaultCreditApplication(merchant!, isSinglePayment)
    }

    sessionStorage.setItem(ESessionStorageKeys.CREDIT_APPLICATION_INFO, JSON.stringify(creditApp))

    navigate(`/${merchantId}/new-app/personal-information`)
  }

  if (merchant)
    return (
      <main className="step-0">
        <h4 className="subtitle">{t('welcome.applyInMinutes')}</h4>
        <h1>{t('welcome.chooseFinancingType')}</h1>
        <div className="paragraph">
          <p>{t('welcome.answerQuestions')}</p>
        </div>
        <button
          id="btnRegularFinancing"
          type="button"
          onClick={() => handleGetStarted(false)}
          className="btn btn-blue"
          style={{ marginBottom: '1px' }}
        >
          <span>{t('welcome.getFinanced')}</span>
          <i className="fa-regular fa-arrow-right" />
        </button>
        <button id="btnSinglePayment" type="button" onClick={() => handleGetStarted(true)} className="btn btn-blue">
          <span>{t('welcome.singlePayment')}</span>
          <i className="fa-regular fa-arrow-right" />
        </button>
      </main>
    )
}

export default WelcomePage
